function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
  id: "xo57pmhwna",
  cx: 8.5,
  cy: 8.5,
  r: 8.5
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-987 -840) translate(127 269) translate(840 503) translate(20 68)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "umq29qgdsb",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#xo57pmhwna"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#C32C24",
  xlinkHref: "#xo57pmhwna"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M4.75 13.286L6.313 8.719 7.712 9.733 8.95 7.795 10.893 12.436 12.421 5.059 14.079 7.118 15.93 -2.782 14.498 -3.049 13.229 3.739 11.62 1.741 10.42 7.533 9.22 4.666 7.316 7.646 5.572 6.381 3.993 10.999 2.284 9.827 0.733 15.009 2.129 15.427 3.107 12.159z",
  mask: "url(#umq29qgdsb)"
}))))));

var SvgImgOveractive = function SvgImgOveractive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImgOveractive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/img-overactive.fc191c5b.svg";
export { ForwardRef as ReactComponent };